<template>
  <div class="row">
    <div class="category">
      <div v-for="category in categories">
        <category-item
          :category="category"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {infoToaster} from "../../services/ErrorHandler";
  import rf from "../../communicate/RequestFactory";
  import CategoryItem from "./CategoryItem";

  export default {
    name: "Categories",
    components: {
      CategoryItem
    },
    data: function () {
      return {
        categories: [],
      }
    },
    mounted() {
      this.loadData();
    },
    methods: {
      loadData() {
        this.$Progress.start();
        rf.getRequest('CategoriesRequest').getCategories().then((res) => {
          this.categories = res.data;
          this.$Progress.finish()
        }).catch(err => {
          infoToaster("Xảy ra lỗi", "Hệ thống đang bảo dưỡng");
          this.$Progress.fail()
        })
      }
    }
  }
</script>

<style scoped>
.category{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/categories/Categories.vue